import { TherapistAction } from '../../actions/constant';

const {
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_REQUEST,
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_SUCCESS,
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_FAILURE,
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_RESET,
} = TherapistAction;

interface ClockInOutButtonVisibilityState {
  // true = show the manual clock in/out button and associated warning pop-ups,
  // false = hide. Any error/404 is treated as false (APIT-587).
  isVisible: boolean;
  loader: boolean;
  // false until the flag has been resolved at least once (SUCCESS or FAILURE).
  // Consumers hide the button/warnings while this is false so the UI never
  // paints a stale value before the fetch lands (kills the late-apply flicker).
  resolved: boolean;
}

const initialState: ClockInOutButtonVisibilityState = {
  isVisible: false,
  loader: false,
  resolved: false,
};

export const clockInOutButtonVisibilityReducer = (
  state = initialState,
  action: any
): ClockInOutButtonVisibilityState => {
  switch (action.type) {
    case GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_REQUEST:
      return {
        ...state,
        loader: true,
      };

    case GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_SUCCESS:
      return {
        ...state,
        isVisible: Boolean(action.payload),
        loader: false,
        resolved: true,
      };

    case GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_FAILURE:
      // Any error/404 -> hide the button and warnings.
      return {
        ...state,
        isVisible: false,
        loader: false,
        resolved: true,
      };

    case GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_RESET:
      return initialState;

    default:
      return state;
  }
};
